export default __webpack_public_path__ + "static/media/xbox-red.a4a710da.png";